import NewTCCoordinator from "../../features/coordinator/NewTCCoordinator"

const NewTCCoordinatorPage = () => {
  return <NewTCCoordinator />
}

export default NewTCCoordinatorPage